export default {"src":"/_next/static/media/research_hub.fd842634.svg","height":284,"width":284};